// German copy is verbatim from the Eclipse handoff reference. English mirrors it.
export const eclipseCopy = {
  de: {
    nav: { products: "Produkte", work: "Zusammenarbeit", loop: "Der Loop", operator: "Operator", cta: "Erstgespräch" },
    hero: {
      h1: "Wir bauen autonome Unternehmen. Und helfen Ihrem, eins zu werden.",
      lead1: "Eigene Produkte in Produktion.",
      lead2: "Dieselbe Architektur für Ihr Unternehmen, auf den Tools, die Sie schon haben.",
      cta: "Erstgespräch anfragen →",
    },
    products: {
      h: "Wir verkaufen nichts, was wir nicht selbst betreiben.",
      webblitz:
        "Autonome KI-Sichtbarkeit. Erkennt Lücken in den Antworten von ChatGPT, Perplexity, Gemini und Claude, bereitet die Maßnahmen vor, setzt sie nach Freigabe um und misst die Wirkung.",
      projectL: "Autonomes Newsletter-System. Recherchiert, schreibt, platziert Sponsoren und versendet. Der Betreiber gibt nur noch frei.",
    },
    work: {
      h: "Was in unseren Produkten läuft, bauen wir auch für Sie.",
      services: [
        {
          title: "KI-Sichtbarkeit",
          body: "Wie KI-Assistenten heute über Sie antworten, und die Arbeit, damit Sie genannt werden statt Ihr Wettbewerber.",
          items: ["Kostenloser Scan als Start", "90-Tage-Programm", "Läuft auf webblitz.ai"],
        },
        {
          title: "Agentic Ops",
          body: "Agenten erstellen, Ihr Team gibt frei. Für jede Rolle mit wiederkehrender Arbeit.",
          items: ["Social- und PR-Entwürfe in Ihrer Stimme", "Monatliches Investoren-Update", "Inbound-Triage ins CRM", "Wöchentlicher KPI-Report"],
        },
        {
          title: "GTM-Engines",
          body: "Eine wiederholbare Pipeline statt Founder-Heldentum.",
          items: ["Account-Recherche und Outreach-Entwürfe", "Follow-up-Rhythmen", "Content aus Ihrer eigenen Arbeit", "ICP-Signal-Monitoring"],
        },
      ],
      base: {
        title: "Das autonome Unternehmen",
        body: "Alles darüber läuft auf derselben Basis. So, wie wir unsere eigenen Unternehmen führen.",
        steps: [
          "Jede Rolle und Aufgabe kartieren",
          "Eine Quelle der Wahrheit, trainierte Skills",
          "Agenten pro Rolle, mit Rhythmen",
          "Sie geben frei, das Unternehmen läuft",
        ],
      },
      terms: [
        ["Budget", "Festes Paket, keine Tagessätze"],
        ["Stack", "Ihre Tools, kein neuer Stack"],
        ["Kontrolle", "Nichts geht raus ohne Freigabe"],
        ["Übergabe", "Ihr Team betreibt es selbst"],
      ] as [string, string][],
    },
    practice: {
      h: "Aus der Praxis: die Kommunikation eines Berliner VCs.",
      before: "Vorher",
      after: "Heute",
      beforeTitle: "Das Team koordiniert jeden Schritt.",
      afterTitle: "Das Team entscheidet, was rausgeht.",
      beforeBody: "Informationen zusammentragen, Entwürfe erstellen, Abstimmungen organisieren. Wiederkehrende Arbeit liegt beim Comms-Team.",
      afterBody: "Notion liefert den Kontext. Trainierte Agenten bereiten Entwürfe vor, klare Rhythmen starten die Arbeit. Das Comms-Team gibt frei.",
      steps: [
        "Notion als einzige Quelle der Wahrheit",
        "Agenten angebunden, trainiert auf Stimme und Entwürfe",
        "Klare Rhythmen und Trigger",
        "Das Comms-Team gibt frei, bevor etwas rausgeht",
      ],
    },
    loop: {
      h: "Jedes System läuft auf demselben Loop. Ein menschlicher Touchpoint.",
      steps: [
        ["Detect", "Das System überwacht Signale selbst."],
        ["Trigger", "Ein Signal startet den Job."],
        ["Draft", "Agenten erstellen das Ergebnis."],
        ["Approve", "Sie geben frei. Sonst nichts."],
        ["Execute", "Das System liefert aus."],
        ["Measure", "Jeder Durchlauf wird gemessen."],
      ] as [string, string][],
    },
    operator: {
      h: "Ein Operator, kein Projektteam-Karussell.",
      rows: [
        ["Operator", "Levent „Levo“ Valente, Gründer rawResponse Labs"],
        ["Background", "12 Jahre Startups · 100+ Gründer:innen von Pre-Seed bis Series A · Lead Company Builder bei Next Big Thing · Antler Alumni"],
        ["Aktuell", "Baut webblitz.ai, bootstrapped"],
        ["Prinzip", "Operator is the constant. Brands are vehicles."],
      ] as [string, string][],
    },
    final: {
      h: "Lassen Sie uns sprechen und sehen, wo Sie stehen.",
      cta: "30 Minuten buchen →",
      note: "Kostenlose Analyse Ihrer KI-Sichtbarkeit und KI-Ops",
    },
    footer: { page: "Seite", contact: "Kontakt", projectL: "Project L. (bald)", imprint: "Impressum", privacy: "Datenschutz", solutions: "Lösungen", agencies: "Für Agenturen", enterprises: "Für Unternehmen", manufacturing: "Für Maschinenbau", resources: "FAQ", about: "Über uns" },
  },
  en: {
    nav: { products: "Products", work: "Working together", loop: "The loop", operator: "Operator", cta: "Intro call" },
    hero: {
      h1: "We build autonomous companies. And help yours become one.",
      lead1: "Our own products in production.",
      lead2: "The same architecture for your company, on the tools you already use.",
      cta: "Request an intro call →",
    },
    products: {
      h: "We sell nothing we don't run ourselves.",
      webblitz:
        "Autonomous AI visibility. Finds gaps in the answers of ChatGPT, Perplexity, Gemini and Claude, prepares the fixes, ships them after approval and measures the impact.",
      projectL: "Autonomous newsletter system. Researches, writes, places sponsors and sends. The operator only approves.",
    },
    work: {
      h: "What runs in our products, we build for you too.",
      services: [
        {
          title: "AI visibility",
          body: "How AI assistants answer about you today, and the work to get you named instead of your competitor.",
          items: ["Free scan to start", "90-day program", "Runs on webblitz.ai"],
        },
        {
          title: "Agentic Ops",
          body: "Agents draft, your team approves. For every role with recurring work.",
          items: ["Social and PR drafts in your voice", "Monthly investor update", "Inbound triage into the CRM", "Weekly KPI report"],
        },
        {
          title: "GTM engines",
          body: "A repeatable pipeline instead of founder heroics.",
          items: ["Account research and outreach drafts", "Follow-up cadences", "Content from your own work", "ICP signal monitoring"],
        },
      ],
      base: {
        title: "The autonomous company",
        body: "Everything above runs on the same foundation. The way we run our own companies.",
        steps: [
          "Map every role and task",
          "One source of truth, trained skills",
          "Agents per role, with cadences",
          "You approve, the company runs",
        ],
      },
      terms: [
        ["Budget", "Fixed package, no day rates"],
        ["Stack", "Your tools, no new stack"],
        ["Control", "Nothing goes out without approval"],
        ["Handover", "Your team runs it themselves"],
      ] as [string, string][],
    },
    practice: {
      h: "In practice: the communications of a Berlin VC.",
      before: "Before",
      after: "Today",
      beforeTitle: "The team coordinates every step.",
      afterTitle: "The team decides what goes out.",
      beforeBody: "Gathering information, writing drafts, coordinating reviews. Recurring work sits with the comms team.",
      afterBody: "Notion supplies the context. Trained agents prepare drafts, clear cadences start the work. The comms team approves.",
      steps: [
        "Notion as the single source of truth",
        "Agents connected, trained on voice and drafts",
        "Clear cadences and triggers",
        "The comms team approves before anything goes out",
      ],
    },
    loop: {
      h: "Every system runs on the same loop. One human touchpoint.",
      steps: [
        ["Detect", "The system monitors signals on its own."],
        ["Trigger", "A signal starts the job."],
        ["Draft", "Agents create the output."],
        ["Approve", "You approve. Nothing else."],
        ["Execute", "The system delivers."],
        ["Measure", "Every run is measured."],
      ] as [string, string][],
    },
    operator: {
      h: "One operator, not a rotating project team.",
      rows: [
        ["Operator", "Levent \"Levo\" Valente, founder of rawResponse Labs"],
        ["Background", "12 years in startups · 100+ founders from pre-seed to Series A · Lead Company Builder at Next Big Thing · Antler alumni"],
        ["Now", "Building webblitz.ai, bootstrapped"],
        ["Principle", "Operator is the constant. Brands are vehicles."],
      ] as [string, string][],
    },
    final: {
      h: "Let's talk and see where you stand.",
      cta: "Book 30 minutes →",
      note: "Free analysis of your AI visibility and AI ops",
    },
    footer: { page: "Page", contact: "Contact", projectL: "Project L. (soon)", imprint: "Imprint", privacy: "Privacy", solutions: "Solutions", agencies: "For agencies", enterprises: "For enterprises", manufacturing: "For manufacturing", resources: "FAQ", about: "About" },
  },
};
